module.exports = __webpack_public_path__ + "img/logo2.8fe2fce8.jpg";